
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...protocolKey]",
      function () {
        return require("private-next-pages/[...protocolKey].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...protocolKey]"])
      });
    }
  